import React from 'react';
import VocabularyRoleActionRow from './VocabularyRoleActionRow';

const VocabularyRoleActionRows = ({
  activeRoleActionUUID,
  onActionSelected,
  onDeleteClicked,
  roleActions,
  updateErrors,
}) => roleActions.map((roleAction) => (
  <VocabularyRoleActionRow
    activeRoleActionUUID={activeRoleActionUUID}
    deleteRoleAction={onDeleteClicked}
    updateErrors={updateErrors}
    key={roleAction.uuid}
    onSelected={onActionSelected}
    roleAction={roleAction}
  />
));

export default VocabularyRoleActionRows;
